// Models
import { OfferModel } from ".";

export class CategoryModel {
	id: string;
	name: string;
	description: string;
	azerbaijaniName: string;
	russianName: string;
	blackImageUrl: string;
	whiteImageUrl: string;
	offers: OfferModel[];
	pageIndex?: number;
}